import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { Usabilla } from '@fs/zion-usabilla'

import PageHead from '../components/PageHead'
import useScrollToAnchor from '../hooks/useScrollToAnchor'
import { buildPageDetails } from '../utils/build-page-detail'

/**
 * A wrapper for the Page component that adds some additional functionality
 * useful for region pages. Namely analytics and SEO metadata.
 * @param {object} props Page props
 * @param {string[]} props.pageDetails Array of unique identifiers for page analytics. For the page version tag, use the year and month the page went live (e.g. "v2025.10")
 * @param {object} props.pageMetadata Object for setting the page metadata
 * @param {string} props.pageMetadata.title Page title
 * @param {string} props.pageMetadata.description Page description
 * @param {string} props.pageMetadata.canonicalLink Page canonical link
 * @param {string} props.pageMetadata.keywords Page keywords
 * @param {string} props.pageMetadata.ogTitle Open Graph title (falls back to title if not provided)
 * @param {string} props.pageMetadata.ogDescription Open Graph description (falls back to description if not provided)
 * @param {string} props.pageMetadata.imageSrc Image URL
 * @param {number} props.pageMetadata.imageWidth Image width
 * @param {number} props.pageMetadata.imageHeight Image height
 * @param {string} props.usabillaURL Usabilla URL
 * @param {React.ReactNode} props.children Page content
 */
export default function RegionPage({ pageDetails, pageMetadata = {}, usabillaURL, children, ...props }) {
  usePageView({ page_detail: buildPageDetails(pageDetails) })
  useScrollToAnchor()

  return (
    <div {...props}>
      <PageHead {...pageMetadata} />
      {children}
      {usabillaURL && <Usabilla url={usabillaURL} />}
    </div>
  )
}
